// extracted by mini-css-extract-plugin
module.exports = {"table":"RrTableRow_table__2i-b6","name":"RrTableRow_name__3RrLx","table-row":"RrTableRow_table-row__usHBU"};